import React, { useRef, useState } from "react";
import { Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { uploadTenantImage } from "../../Services/TennantContentService";
import { resolveMediaUrl } from "../../utils/seo";

const ImageUploadField = ({
  label,
  field,
  value,
  onUploaded,
  onError,
  hint = "تصویر بلافاصله ذخیره می‌شود. فرمت‌های مجاز: JPG، PNG یا WEBP — حداکثر ۵ مگابایت",
  rounded = false,
}) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleSelect = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setUploading(true);
    try {
      const data = await uploadTenantImage(file, field);
      if (data?.imageUrl) {
        onUploaded(data.imageUrl);
      }
    } catch (error) {
      onError?.(error?.message || "خطا در آپلود تصویر");
    } finally {
      setUploading(false);
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    }
  };

  return (
    <div className="mb-3">
      <label className="form-label iran-sans">{label}</label>
      <div
        className="d-flex flex-column flex-md-row align-items-md-center gap-3 p-3"
        style={{
          border: "1px dashed rgba(5, 50, 81, 0.25)",
          borderRadius: "12px",
          background: "#f8fafb",
        }}
      >
        <div
          style={{
            width: rounded ? 96 : 140,
            height: rounded ? 96 : 90,
            borderRadius: rounded ? "50%" : "10px",
            overflow: "hidden",
            background: "#e9eef2",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {value ? (
            <img
              src={resolveMediaUrl(value)}
              alt={label}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <span className="text-secondary iran-sans" style={{ fontSize: "0.8rem" }}>
              بدون تصویر
            </span>
          )}
        </div>

        <div>
          <input
            ref={inputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp"
            hidden
            onChange={handleSelect}
          />
          <Button
            variant="contained"
            startIcon={<CloudUploadIcon />}
            disabled={uploading}
            onClick={() => inputRef.current?.click()}
            sx={{
              backgroundColor: "#053251",
              "&:hover": { backgroundColor: "#075079" },
              fontFamily: "inherit",
            }}
          >
            {uploading ? "در حال آپلود..." : "آپلود تصویر"}
          </Button>
          <div className="text-secondary iran-sans mt-2" style={{ fontSize: "0.8rem" }}>
            {hint || "تصویر بلافاصله ذخیره می‌شود"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageUploadField;
